import { forwardRef, InputHTMLAttributes, ReactNode, useRef } from 'react'

import { useForceUpdate } from '@/app/hooks/useForceUpdate'

import AppInputMasked from './AppInputMasked'

type Props = InputHTMLAttributes<HTMLInputElement> & {
  invalid?: boolean
  invalidMessage?: ReactNode
  onAccept?: (value: string) => void
  dataTestId?: string
}

const AppInputPhoneMasked = forwardRef<HTMLInputElement, Props>(
  ({ onAccept, value, ...props }, ref) => {
    const forceUpdate = useForceUpdate()
    const inputRef = useRef<HTMLInputElement>(null) as {
      current: HTMLInputElement | null
    }
    const isSelectedRef = useRef(false)

    return (
      <AppInputMasked
        type="tel"
        name="phone"
        autoComplete="tel"
        mask="+7 000 000 00 00"
        placeholderChar="_"
        lazy={true}
        inputRef={(el: any) => {
          if (ref && el) {
            ;(ref as any).current = el
          }
          inputRef.current = el
        }}
        value={value as string}
        onKeyDown={() => {
          if (inputRef.current) {
            const selectionStart = inputRef.current.selectionStart
            const selectionEnd = inputRef.current.selectionEnd
            const valueLength = inputRef.current.value.length

            isSelectedRef.current =
              selectionStart === 0 && selectionEnd === valueLength
          }
        }}
        onAccept={(newValue, { unmaskedValue }) => {
          if (
            isSelectedRef.current &&
            unmaskedValue === '8' &&
            newValue === '+7 8'
          ) {
            isSelectedRef.current = false
            return onAccept?.('+7')
          }

          if (unmaskedValue.startsWith('+7') || unmaskedValue === '') {
            return onAccept?.(newValue)
          }

          return onAccept?.(`+7${unmaskedValue}`)
        }}
        onPaste={event => {
          const numbers = event.clipboardData
            .getData('text/plain')
            .replaceAll(/\D/g, '')
            .slice(-10)
          if (numbers.length === 10) {
            onAccept?.(`+7${numbers}`)
            forceUpdate()
          }
        }}
        {...props}
      />
    )
  }
)

AppInputPhoneMasked.displayName = 'AppInput'
export default AppInputPhoneMasked
